import styled from 'styled-components';

export const IFrame = styled.iframe`
  min-height: 800px;
  width: 100%;
  border: none;
  border-radius: 0.5rem;
`;
